import {Box, Text, UseModalProps} from '@chakra-ui/react';
import {AlertDialog} from 'components/shared';
import {useFormDate} from 'hooks';
import {useRouter} from 'next/router';
import {FC} from 'react';
import {TranslationKeys} from 'translations';
import {ITimetable, ProviderTypeEnum} from 'types';

export interface IModalProps extends UseModalProps {
  timetable?: ITimetable;
  name: string;
  t: (term: TranslationKeys) => string;
  providerType?: ProviderTypeEnum;
  title?: string;
  acceptsPreorder?: boolean;
  message?: string;
  isOnPause?: boolean;
}

export const ClosedProviderBanner: FC<IModalProps> = ({
  t,
  isOpen,
  onClose,
  name,
  timetable,
  providerType,
  title,
  acceptsPreorder,
  message,
  isOnPause,
}) => {
  const {push} = useRouter();
  const {date: nextOpeningDate} = useFormDate(timetable?.next_opening_datetime ?? '', 'HH:mm / dd.MM.yyyy');
  const {date: willOpenTime} = useFormDate(timetable?.from_datetime ?? '', 'HH:mm');

  const onConfirm = () => {
    push(`/${providerType}s`);
  };

  const alertTitle = title ? title : `${name} ${t('OPEN_PROVIDER_IN')} ${willOpenTime || nextOpeningDate}`;

  const messageText = (message || t('PAUSE_PROVIDER_DESCRIPTION')).replace(
    '%providerName%',
    `<strong>${name}</strong>`,
  );

  return (
    <AlertDialog
      title={!isOnPause ? <Text>{alertTitle}</Text> : null}
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      successButtonValue={t('OPEN_PROVIDER')}
      cancelButtonValue={
        isOnPause ? t('CONTINUE_HERE') : isOpen && acceptsPreorder ? t('ADD_PRE_ORDER') : t('CONTINUE_HERE')
      }
    >
      <Box w="100%">
        <Text
          whiteSpace="pre-line"
          fontWeight="500"
          dangerouslySetInnerHTML={{
            __html: messageText,
          }}
        />
      </Box>
    </AlertDialog>
  );
};
